import { useTranslation } from "react-i18next";

/**
 * HelpsCreateDiag
 *
 */
const HelpsShowdashboardGlobal = () => {
  const { t } = useTranslation()
  return (
    <>
      {t(
        "core:pages.osculteo.results.help.global"
      )}
    </>
  );
};

export { HelpsShowdashboardGlobal };

const HelpsShowdashboardSerp = () => {
  const { t } = useTranslation()
  return (
    <>
      {t(
        "core:pages.osculteo.results.help.serp"
      )}
    </>
  );
};

export { HelpsShowdashboardSerp };

const HelpsShowdashboardImage = () => {
  const { t } = useTranslation()
  return (
    <>
      {t(
        "core:pages.osculteo.results.help.images"
      )}
    </>

  );
};

export { HelpsShowdashboardImage };

const HelpsShowdashboardSuggest = () => {
  const { t } = useTranslation()
  return (
    <>
      {t(
        "core:pages.osculteo.results.help.suggest"
      )}
    </>
  );
};

export { HelpsShowdashboardSuggest };

const HelpsShowdashboardPrivateData = () => {
  const { t } = useTranslation()
  return (
    <>
      {t(
        "core:pages.osculteo.results.help.privateData"
      )}
    </>
  );
};

export { HelpsShowdashboardPrivateData };

const HelpsShowdashboardPrivateUrl = () => {
  const { t } = useTranslation()
  return (
    <>
      {t(
        "core:pages.osculteo.results.help.privateURL"
      )}
    </>
  );
};

export { HelpsShowdashboardPrivateUrl };

// const HelpsShowdashboardPrivateFacebook = () => {
//   return (
//     <>
//       L'onglet "Facebook"vous permet l'accès aux données
//       personnelles utilisées par ce réseau social. Cette fonctionnalité vous
//       permet de centraliser et de gérer vos informations Facebook depuis
//       Osculteo. Vous pourrez ainsi examiner et contrôler les données que vous
//       partagez sur la plateforme, vous assurant que votre présence sur les
//       médias sociaux est conforme à vos souhaits en matière de confidentialité.
//       Nous sommes là pour faciliter cette intégration et vous aider à tirer le
//       meilleur parti de votre compte Facebook tout en préservant votre vie
//       privée en ligne
//     </>
//   );
// };

// export { HelpsShowdashboardPrivateFacebook };
